/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { businessInterface } from "../interfaces/businessInterface";
import { DashboardLayout } from "../components/Dashboard";
import { TableGen2 } from "../components/table-gen-2";
import { ModalOperation } from "../components/ModalOperation";
import { requestHttp } from "../api/services-third-parties";
import { ValidAccessToken, formatDate, stringMin } from "../core/function/function-generic";
import { PlusCircleIcon } from "@heroicons/react/24/outline";

interface Props {
    onSearchGen: string;
}

export const Roles = ({ onSearchGen }: Props) => {
    const state = useSelector((state: { business: businessInterface }) => state.business);
    const [msg, setMsg] = useState('')
    const [open, setOpen] = useState(false);
    const [dataRole, setRole] = useState([]);
    const [dataTable, setDataTable] = useState({
        divContent: 'table-info w-full h-[60vh]',
        classTable: 'w-full min-w-max table-auto',
        columns: [
            {
                nameColumn: "User",
                keysColumns: 'user',
                classThHead: 'pl-6 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-6 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Role",
                keysColumns: 'role',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-medium leading-5'
            },
            {
                nameColumn: "Status",
                keysColumns: 'status',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
            },
        ],
        data: [],
        classTrBody: 'bord-th-body-table',
        totalPages: 0,
        isAction: false,
        actionIcon: [],
        iconClass: `border-fff`
    });

    useEffect(() => {
        document.body.style.background = "#FFF";
        ValidAccessToken()

        getUserRoles(state.id, 0);

    }, []);

    const getUserRoles = async (id: number | null, pages: number) => {
        try {
            const response = await requestHttp(
                `/Auth/business/user-rol/${state.id}`,
                'GET',
            )

            responseRequest(response);

        } catch (err) {
            console.error(err);
        }
    }

    const responseRequest = (response: any) => {
        if ([400].includes(response.data.statusCode)) {
            setRole([]);
            setDataTable((prevDataTable) => ({
                ...prevDataTable,
                //data: [],
                totalPages: 1
            }));
        }

        if ([202].includes(response.data.statusCode)) {
            const res = response.data['data']['data'];
            const totalPages = response['data']['data']['meta']['pageCount'];

            setRole(res);
            setDataTable((prevDataTable) => ({
                ...prevDataTable,
                data: dataMap(res),
                totalPages: totalPages
            }));
        }
    }

    const dataMap = (row: any) => {
        return row.map((item: any, index: number) => {
            return {
                user: (
                    <div key={index}>
                        <p className="mb-[10px] text-[#101828] text-[1rem] not-italic font-[Montserrat] font-semibold leading-[normal]"> {item.name || 'N/A'} </p>
                        <p className="text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5"> {item.email} </p>
                    </div>
                ),
                role: (
                    <div className="bg-[#ECECEC] text-[#101828] text-center rounded-full w-1/2">
                        {stringMin(item.role)}
                    </div>
                ),
                status: (
                    <div className="" key={index}>
                        <p className="mb-[10px] text-[#101828] text-[16px] not-italic font-[Montserrat] font-medium leading-[22px]"> {item.active ? 'Active' : 'Inactive'}</p>
                        <p className="text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5"> {formatDate(item.date)} </p>
                    </div>
                )
            }
        })
    }

    const handleNextPageClick = (e: any) => {

    }

    const onAction = (e: any) => {

    }

    const onOpenModal = (e: any) => {
        setOpen(true)
    }

    const closeModal = (e: boolean) => {
        setOpen(e);
    }

    const onsubmitModal = async (event: any) => {
        const response = await requestHttp(
            `/cms-business/business/user`,
            'POST',
            event
        )

        if (response.statusCode === 422) {
            setMsg(`There was an internal error`)
            return
        }

        if (response['data'].statusCode === 201) {
            setMsg(`Successful registration`)
            getUserRoles(state.id, 0);
            setTimeout(() => {
                setMsg(``)
                setOpen(false)
            }, 8000);
        } else {
            setMsg(`There was an internal error`)
            return
        }
    }

    return (
        <>
            <DashboardLayout pageTitle="Team" onSearchGen={onSearchGen}>
                <div className="flex justify-end w-full relative top-[-4.5rem]">
                    <button type="button" className="btn-upload-submit" onClick={onOpenModal}><PlusCircleIcon className="w-[1.5rem]" /> Invite User</button>
                </div>
                {
                    msg !== '' && (
                        <div>
                            {msg}
                        </div>
                    )
                }
                <ModalOperation
                    operationDetails={null}
                    isOpen={open}
                    closeModal={closeModal}
                    typeOperation={'addRoleUser'}
                    onsubmitModal={onsubmitModal}
                />

                <TableGen2
                    dataTableGen={dataTable}
                    handleNextPageClick={handleNextPageClick}
                    onAction={onAction}
                />
            </DashboardLayout>
        </>
    )


}